import axios from 'axios'
import router from '@/router'
import store from '@/store'
import { refreshToken } from '@/lib/session'
import get from 'lodash/get'
// import { refreshError } from '@/lib/utils'

const stack = require('@/stack.json')
// const appVersion = require('@/.version.json')

// Export custom axios object to allow local testing
var defaultAxios = (opts = {}) => {
  let options = Object.assign(
    {
      auth: true,
      loaderDelay: 400, // in milliseconds
      skipVersionCheck: false,
    },
    opts,
  )
  if (options.auth) refreshToken()

  let axiosOpts = {
    baseURL: stack.Endpoint,
  }
  if (options.auth) {
    axiosOpts.headers = {
      Authorization: `Bearer ${window.localStorage.getItem('idToken')}`,
    }
  }
  let a = axios.create(axiosOpts)

  // When an ajax call is made, set a time to start the loader in 400 ms. After the response returns, if the timer is not null
  // (i.e., still active) cancel it. This will show the loader only if a request task > 400 ms.
  let timer
  a.interceptors.request.use(function(config) {
    timer = setTimeout(() => {
      store.commit('incLoader')
      timer = null
    }, options.loaderDelay)
    return config
  })
  a.interceptors.response.use(
    function(response) {
      if (timer !== null) {
        clearTimeout(timer)
      } else {
        store.commit('decLoader')
      }
      // At this time, we will disable this functionality since it's not going to work over a CDN that doesn't
      // invalidate the cache immediately.
      // if (
      //   !options.skipVersionCheck &&
      //   appVersion['version'] !== response.headers['x-client-version']
      // ) {
      //   signOut()
      //   refreshError('The application has been updated.')
      //   // After half a second, reload the page and go to the login page
      //   // This didn't work in IE when it wasn't on a timeout
      //   setTimeout(() => {
      //     location.reload(true)
      //     router.push({ name: 'login' })
      //   }, 500)
      // }
      return response
    },
    function(error) {
      if (timer !== null) {
        clearTimeout(timer)
      } else {
        store.commit('decLoader')
      }
      return Promise.reject(error)
    },
  )

  if (options.auth) {
    // Handle errors from authentication/authorization.
    a.interceptors.response.use(
      function(response) {
        return response
      },
      function(error) {
        if (get(error, 'response.status') === 401) {
          // If there is a pending redirect, make sure the login vue knows about it by passing it as a query param
          let redirect = window.localStorage.getItem('redirect-url')
          if (redirect) {
            router.push({ name: 'login', query: { redirect: redirect } })
          } else {
            router.push({ name: 'login' })
          }
          return Promise.reject({
            message: 'Your session has expired. Please log in again.',
          })
        }
        return Promise.reject(error)
      },
    )
  }
  return a
}

export default defaultAxios
